<template>
  <div class="tweet-media mb-2">
    <tweet-uploaded-images v-if="media[0].file" :images="media"></tweet-uploaded-images>
    <tweet-images v-if="media[0].type === 'photo'" :images="media" />
    <tweet-gif v-else-if="media[0].type === 'animated_gif'" :gif="media[0]"/>
    <tweet-video v-else-if="media[0].type === 'video'" :video="media[0]"/>
    <tweet-link v-else-if="media[0].type === 'link'" :link="media[0]"/>
  </div>
</template>
<script>
import TweetGif from "./TweetGif";
import TweetVideo from "./TweetVideo";
import TweetLink from "./TweetLink";
import TweetImages from "./TweetImages";
import TweetUploadedImages from "./TweetUploadedImages";

export default {
  name: 'TweetMedia',
  components: {TweetUploadedImages, TweetImages, TweetLink, TweetVideo, TweetGif},
  props: ['media']
}
</script>
